/**************************************************
* original
**************************************************/
const sanko = {
  common: {},
  top: {},
  itemList: {},
  itemDetail: {},
  cart: {},
  shop: {},
  company: {},
  order: {},
  uniform: {},
};

/**
* ページ上部のトピックスの表示制御
*/
sanko.common.information = function() {
  const topicsContainer = $('.js-header-topics-container');
  const closeButton = $('.js-header-topics-close');
  const topicsCookie = illm.common.getCookie('topics-hidden');

  // ページ読み込み時に、クッキーがなければトピックスを表示
  if(topicsCookie == null){
    topicsContainer.show();
    $('body').addClass('is-header-topics');
  }

  // 閉じるボタンクリックで、トピックス非表示
  if (closeButton.length > 0) {
    closeButton.on('click', function() {
      topicsContainer.slideUp(500);
      // セッションCookie（ブラウザ閉じたら消える）
      illm.common.setCookie('topics-hidden', 'true', { session: true });
    });
  }

  // 2つ以上の場合カルーセル
  new Splide('.js-information-carousel', {
    type   : 'loop',
    direction: 'ttb',
    height: '26px',
    speed: 1000,
    autoplay: true,
    interval: 3000,
    pauseOnHover: false,
    arrows: false,
    pagination: false,
  }).mount();

};

/**
* ヘッダーメニューの表示制御
*/
sanko.common.setupHeaderMenuToggle = function() {
 const $panels = $('.js-header-panel');
 $panels.each(function(_, panel) {
   const $panel = $(panel);

   $panel.find('.js-header-panel-button').on('click', function() {
    console.log($(this));
     //スマホで、ハンバーガーメニューを展開時
     if(illm.common.isSmartphone()){
      // クリックしたヘッダーメニューが×ボタンであれば、メニューを閉じる
      if($(this).hasClass('is-close-button')){
         $panels.removeClass('is-open');
         $('body').removeClass('overflow-hidden-desktop is-open-header');// shopifyの仕様に倣う
        $('.js-header-panel-close').removeClass('is-close-button');
         return;
      }else {
        //×ボタンでなければ、×アイコンに閉じるボタン用のclassを付与
        $('.js-header-panel-close').addClass('is-close-button');
      }
     }
     
     // 開いてなかったら、他を閉じてから自分を開く
     if(!$panel.hasClass('is-open')){
       $panels.removeClass('is-open');
       $panel.addClass('is-open');
       $('body').addClass('overflow-hidden-desktop is-open-header');// shopifyの仕様に倣う
     }
   });

 });
 
 // ドキュメント全体にクリックイベントを設定
 $(document).on('click', function (event) {
   // パネルが開いていなければ何もしない
   if (!$panels.hasClass('is-open')) {
     return;
   }

   // クリックされた要素がパネル内の .js-header-panel-content かボタンなら無視
   if (
     $(event.target).closest('.js-header-panel-content').length ||
     $(event.target).closest('.js-header-panel-button').length
   ) {
     return;
   }

   // それ以外の場所なら閉じる
   $panels.removeClass('is-open');
   $('body').removeClass('overflow-hidden-desktop is-open-header');// shopifyの仕様に倣う
 });
};

/**
* ヘッダーの候補ワードの検索処理
*/
sanko.common.search = function() {
 // 候補の検索ワードをクリックしたら
 $('.js-search-word').on('click', function(){
   const targetWord = $(this).text().trim();// クリックした検索ワード
   // inputの値を動的に設定して、検索にかける
   $('.js-search-input').val(targetWord);
   $('#js-search-form').submit();
 });
};

/**
* ヘッダーのおすすめアイテム
*/
sanko.common.recommendSlider = function() {
 const mySwiper = new Swiper('.js-header-recommend', {
   slidesPerView: 2.6,
   freeMode: {
     enabled: true,// 自由にドラッグ（スワイプ）できるようにする
   },
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
 });
};

/**
* アコーディオンメニュー
*/
sanko.common.accordion = function() {
 /*「js-accordion-button--sp」classが付いている場合は、スマホでのみ処理
  * ついてない場合は、PC・スマホどちらでも処理 */
 
 //is-openが付いてたら、ページ読み込み時に既にオープン状態
 $( '.js-accordion-button' ).each( function (){
   if( $( this ).hasClass( 'js-accordion-button--sp' ) && illm.common.isSmartphone() || !$( this ).hasClass( 'js-accordion-button--sp' ) ){
     if( $( this ).hasClass( 'is-open' ) ){
       $( this ).siblings( '.js-accordion-contents' ).slideToggle();
     }
   }
 });

 //クリックしたらオープン
 $( '.js-accordion-button' ).on( 'click',function(){
   if( $( this ).hasClass( 'js-accordion-button--sp' ) && illm.common.isSmartphone() || !$( this ).hasClass( 'js-accordion-button--sp' ) ){
     $( this ).siblings( '.js-accordion-contents' ).slideToggle();
     $( this ).toggleClass( 'is-open' );
   }
 });
};

/**
* タブ切り替え
*/
sanko.common.tabswitch = function(targetTab) {
 const tabContainer = targetTab.parents( '.js-tab__container' );
 const activeClass = 'is-active';//アクティブclass

  //一旦リセットして、該当のタブをアクティブ化
  tabContainer.find('.js-tab__button, .js-tab__content').removeClass(activeClass);
  targetTab.addClass(activeClass);

  //該当コンテンツをアクティブ化
  const targetTabIndex = tabContainer.find('.js-tab__button').index(targetTab);
  tabContainer.find('.js-tab__content').eq(targetTabIndex).addClass(activeClass);
};

/*
* 「新作」アイコンの表示制御（発売日から30日以内なら表示）
* @param date サーバー時間
*/
sanko.common.newicon = function(date) {
  const newBadgePeriodDays = 30; // newアイコンを表示しておく期間（日）
  const hiddenClass = 'hidden';// 非表示class名
  const nowDate = date;// 現在日時

  $('.js-new-icon').each(function(){
    // 発売日を取得
    const releaseDate = new Date($(this).data().releaseDate);// 例：{releaseDate: '2025-12-31'}
    if(isNaN(releaseDate.getTime())){
      return;// 無効な日付ならスキップ
    }

    // 発売日の開始時刻を 0:00:00.000 に設定
    releaseDate.setHours(0, 0, 0, 0);

    // 表示終了日時 = 発売日からnewBadgePeriodDays日後の23:59:59.999
    const displayEndDate = illm.common.dateUtil.getEndDateByDays(releaseDate, newBadgePeriodDays);
    
    // 現在時刻が表示期間内ならアイコンを表示
    if (illm.common.dateUtil.isWithinRange(nowDate, releaseDate, displayEndDate)) {
      $(this).removeClass(hiddenClass);
    }
  });

  /*const newBadgePeriodDays = 30;//newアイコンを表示しておく期間（日）
  const newBadgePeriodMs = newBadgePeriodDays * 24 * 60 * 60 * 1000;// ミリ秒に変換
  const currentTime = date.getTime();//1970年1月1日 00:00:00から経過した時間を秒単位に変換（UNIX時間）
  const hiddenClass = 'hidden';//非表示class名

  $('.js-new-icon').each(function(){
    // 発売日を取得
    const releaseDate = new Date($(this).data().releaseDate);// 例：{releaseDate: '2025-12-31'}
    releaseDate.setHours(0, 0, 0, 0); // 発売日の時間を00時00分00秒000ミリ秒～とする
    const releaseDateTime = releaseDate.getTime();//UNIX時間に変換
    if(isNaN(releaseDateTime)){
      return;// 無効な日付ならスキップ
    }

    // 表示終了日時 = 発売日0:00 + 30日 + その日の23:59:59.999
    const displayDeadline = new Date(releaseDate.getTime() + newBadgePeriodMs);
    displayDeadline.setHours(23, 59, 59, 999);
   
    //今が表示終了日時よりも前であれば、「新作」アイコンを表示
    if(currentTime <= displayDeadline.getTime()){
      $(this).removeClass(hiddenClass);
    }
  });*/
};

/**
 * トグルのパネル表示
 */
sanko.common.setupTogglePanel = function() {
  const openClass = 'is-open';//アクティブclass

  $('.js-panel-button').each(function(){
    //ボタンクリックで、要素を展開
    $(this).on('click', function(){
      $(this).parents('.js-panel-container').toggleClass(openClass);
      $('body').toggleClass('is-panel-open overflow-hidden-desktop');
    });
  
    //オーバーレイ・閉じるボタンクリックで、閉じる
    $('.js-panel-overlay, .js-panel-close').on( 'click',function(){
      $(this).parents('.js-panel-container').removeClass(openClass);
      $('body').removeClass( 'is-panel-open overflow-hidden-desktop');
    });
  });
};

/**
 * ヘッダーの色の制御
 */
sanko.common.controlHeaderColor = function() {
  //画像の高さを取得するため、画像読み込み後に実行
  $(window).on('load', function(){
    const targetClass = ".header, .c-breadcrumbs__items"; // ヘッダーとパンくず要素
    const whiteHeaderClass = "is-white"; //スクロール中のclass
    const pageTitleHeight = $(".js-light-header-section").height();
    //ページ読み込み時、ヘッダーは白
    $(targetClass).addClass(whiteHeaderClass);
    //スクロール
    $(window).on("scroll", function () {
      if ($(this).scrollTop() >= pageTitleHeight) {
        //ページタイトルよりも下にスクロールしたら、ヘッダーは黒
        $(targetClass).removeClass(whiteHeaderClass);
      }else{
        //ページタイトルに被っている場合は、ヘッダーは白
        $(targetClass).addClass(whiteHeaderClass);
      }
    });
  });
};

/**
 * ヘッダーやパンくずリストの高さを考慮して、
 * メインコンテンツの位置を上に詰める処理
 * 
 * 目的：
 * メインコンテンツをドキュメントの最上部にピタッとくっつけるため、
 * 上部要素（ニュース・ヘッダー・パンくず）の高さ分だけネガティブマージンで調整する
 */
sanko.common.updateMainContentPosition = function() {
  const header = document.querySelector('.header-wrapper'); // ヘッダー
  const breadcrumb = document.querySelector('.c-breadcrumbs'); // パンくず
  const mainContent = document.querySelector('.js-align-top'); // メインコンテンツ

  /* メインコンテンツをドキュメントの最上部にピタッとくっつけたいため、
   * メインの上にあるニュース・ヘッダー・パンくずの高さ分、ネガティブマージンで上にあげる */
  if (header && mainContent) {
    // 各要素の高さ取得。要素が存在しない場合は高さを0とする
    const headerHeight = header.offsetHeight;
    const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 0;

    // パンくずリストに設定されたマージンを取得
    let breadcrumbMarginTop = 0;
    if (breadcrumb) {
      const computedStyle = window.getComputedStyle(breadcrumb);
      const marginTop = computedStyle.getPropertyValue('margin-top');
      breadcrumbMarginTop = parseFloat(marginTop);
    }

    // メインコンテンツにネガティブマージンを設定
    mainContent.style.marginTop = `-${headerHeight + breadcrumbHeight + breadcrumbMarginTop}px`;
  }

}
  
  
/**
* 商品カードの画像のカルーセル
*/
sanko.common.itemCarousel = function() {
 document.querySelectorAll('.js-item-carousel').forEach(slider => {
   new Splide(slider, {
     type: 'loop',
     speed: 1000,       // スライド切り替え速度（ms）
     pagination: false, // ページネーション（ドットナビ）を表示しない
     drag: false,       // ドラッグ操作でのスライドを無効化
   }).mount();          // Splide を実際に動作させる（初期化）
 });
};

/**
* 2カラムのMVを１カラムに置き換え
*/
sanko.top.adjustForMobileMainvisual = function() {
  // スマホ時にのみ実行
  illm.common.onResize(illm.common.breakpoint.sp, function(){
    // 1枚ずつスライドさせるために、1アイテム2ブロックをばらして、1アイテム1ブロックにする
    $('.home-visual__blocks').each(function () {
      const $block = $(this);
      const $items = $block.find('.home-visual__item');
      $items.each(function () {
        const content = $(this).html();
        const $newBlock = $('<div class="home-visual__blocks parallax-image"></div>').html(content);
        // 元の親ブロックの前に新しいブロックを挿入
        $block.before($newBlock);
      });
      // 元の親 `.home-visual__blocks`（複数アイテムを持っていた要素）を削除
      $block.remove();     
    });
 });
};

/**
* キャプションの位置を制御
*/
sanko.top.moveMainVisualCaption = function() {
}

/**
* スクロールで画像をパララックス（明るさ調整）
*/
sanko.top.parallaxImageEffect = function() {
  // 明るさ（最大で50%暗くする）
  const brightness_adjustment_factor = 0.5;
  
  // スクロール
 $(window).on('scroll', function () {
   $('.parallax-image').each(function (index) {
     const $block = $(this);
     const $prevBlock = $block.prev();
     const blockTop = $block.offset().top;
     const scrollTop = $(window).scrollTop();
     const windowHeight = $(window).height();
 
     // スクロール量に応じて値を0〜1に正規化
     const progress = (scrollTop + windowHeight - blockTop) / windowHeight;
     const clamped = Math.max(0, Math.min(progress, 1));
 
     // スクロール量に応じて、背面の画像を明るくする
     $prevBlock.css({
       /*filter: `brightness(${1 - clamped * brightness_adjustment_factor})` // 最大で50%暗く*/
       '--overlay-opacity': `${clamped * brightness_adjustment_factor}` // 1 → 0.5に向かって透明化
     });
      /* if (index === 1) {
        console.log(scrollTop,windowHeight,blockTop);
      } */

    // キャプションを上に移動
    /*const $caption = $prevBlock.find('.home-visual__heading');
    if ($caption.length) {
      // 元の bottom を50pxとしてスクロールで最大100px上に移動させる例
      const maxMove = 600; // 最大移動距離
      const newBottom = 50 + clamped * maxMove;

      $caption.css('bottom', `${newBottom}px`);
    }*/
   });
 });
};

/**
* 「私たちのモノづくり」のスライダー
*/
sanko.top.featureSlider = function() {
  const slideSpeed = 1000;// スライド時のスピード
  const slideDelay = 3000;//自動再生の間隔
  // const pcBreakpoint = illm.common.breakpoint.pc;//PCのブレークポイント

  const shopSwiper = new Swiper('.js-home-blog-slider', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true // フェード中に前後スライドをクロスフェード
    },
    loop: true,
    slidesPerView: 'auto',
    speed: slideSpeed,
    allowTouchMove: false,
    autoplay: {
      delay: slideDelay,           // 自動再生の間隔
      disableOnInteraction: false,
    }
  });
}

/**
* 絞り込みメニューをスクロールアップで表示
*/
sanko.itemList.scrollUpRevealFilter = function(){
 let lastScrollTop = 0;
 let isSticky = false;
 const $filterBar = $('.js-filter-sticky');//絞り込みメニュー
 const headerHeight = $('header').outerHeight();
 const filterBarOffset = $filterBar.offset().top - headerHeight; // トリガー位置より下でのみ動作

 $(window).on('scroll', function() {
   const currentScroll = $(this).scrollTop();//現在のスクロール位置

   //トリガー位置の下までスクロールしたら
   if (currentScroll > filterBarOffset){
     $filterBar.addClass('is-sticky');
     
     // 上にスクロールしているときだけ固定して表示
     if(currentScroll < lastScrollTop){
       if (!isSticky) {
         $filterBar.css('top',headerHeight);
         isSticky = true;
       }
     // 下にスクロールしているときだけ固定して表示
     }else{
       $filterBar.css('top','');
       if (isSticky) {
         isSticky = false;
       }
     }
   // トリガー位置より上にいるときは常に通常位置
   }else{
     $filterBar.css('top',0);
     if (isSticky) {
       $filterBar.removeClass('is-sticky');
       isSticky = false;
     }
   }
   lastScrollTop = currentScroll;
 });
};


/**
* 絞り込みメニューを非表示制御（スマホ）
*/
sanko.itemList.controlDisplayFilter = function(){  
  // スマホ以外の場合は、処理しない
  if( !illm.common.isSmartphone() ){
    return;
  }
  
  // 「絞り込み検索」ボタン
  const facetsButton = document.getElementById("mobile-facets");

  window.addEventListener("scroll", () => {
    // スクロール量
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    // 表示領域の高さ
    const windowHeight = window.innerHeight;
    // ページ全体の高さ
    const docHeight = document.documentElement.scrollHeight;

    if (scrollTop + windowHeight >= docHeight-50) {
      // 最下部に到達したらフェードアウト
      facetsButton.classList.add("hide");
    } else {
      // それ以外は表示
      facetsButton.classList.remove("hide");
    }
  });
}

/**
* 絞り込みメニューを閉じる処理
*（PCで、デフォルトだと背景クリックで閉じるが、その処理をスキップして別カテゴリクリックでメニュー表示を切り替えたい）
*/
/*sanko.itemList.CloseFilterMenu = function(){
  // PCで
  if(illm.common.isPC()){
    // 絞り込みメニューをクリックしたら、
    $('.js-filter').on('click', function(){
      if($(this).prop('open')){
        $(this).removeAttr('open');
      }else{
        // 一旦開いているのを閉じてから、対象のメニューを展開
        $('.js-filter').removeAttr('open');
      }
    });
  };
}*/

/**
* 商品画像のスライダー
*/
sanko.itemDetail.productSlider = function(){
  const mainSlider = '.js-product-slider';// メインスライダー
  const thumbSlider = '.js-product-thumb-slider';//サムネイル
  const pcBreakpoint = illm.common.breakpoint.pc;//PCのブレークポイント
  const mySwiper_thumb = new Swiper(thumbSlider, {
    freeMode: true,
    slidesPerView: 4,
    /*watchSlidesVisibility: true,*/
    watchSlidesProgress: true,
    breakpoints: {
      [pcBreakpoint]: {
        direction: 'vertical',      // ← 縦方向にする！
        slidesPerView: 'auto',
      }
    }
  });
  const mySwiper_main = new Swiper(mainSlider, {
    slidesPerView: 1,
    breakpoints: {
      [pcBreakpoint]: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    },
    thumbs: {
      swiper: mySwiper_thumb,
    },
  });
};

/**
* 商品画像の拡大処理
*/
sanko.itemDetail.zoomProductImages = function(){
 const productImage = '.js-product-slider img';//商品画像
 const activeClass = 'is-active';//アクティブclass
 let clickCount = 0; //商品画像をクリックした回数
 let scrollPosition = 0; //スクロール位置を保持する変数

 // bodyの開始タグの直下に拡大用の空のDOMを生成
 const html = `
   <div class="js-image-zoom__container">
     <div class="js-image-zoom__close"></div>
     <div class="js-image-zoom-wrap">
       <ul class="js-image-zoom"></ul>
       <div class="js-image-zoom-active"></div>
     </div>
   </div>
 `;
 $('body').prepend(html);

 //商品画像をクリックしたら
 $( productImage ).on( 'click',function(){

   //1度目のクリックであれば、拡大用ののDOM生成　※2度目以降は作る必要がないのでスルー
   if (clickCount === 0) {
     $( productImage ).each(function () {
       // 新しいli要素を作成し、img要素を追加
       const productImg = $( '<li>' ).append( $( this ).clone() );
       //あらかじめ用意してあるズーム用の要素に商品画像のimgを追加
       $( '.js-image-zoom' ).append( productImg );
     });

     //他のサムネイル画像をクリックしたら
     $( `.js-image-zoom li:not(.${activeClass})` ).on( 'click', function(){
       //アクティブクラスを初期化
       $( '.js-image-zoom li' ).removeClass( activeClass );
       //アクティブクラスを付与
       $( this ).addClass(activeClass);
       //拡大画像を初期化してから、切り替える
       //$( '.js-image-zoom-active' ).html( '' ).append( $( this ).clone() );
     });

     //クリック回数のカウント
     clickCount++;
   }

   //アクティブclassを付与して、対象の画像を拡大する
   /*$( '.js-image-zoom li' ).removeClass( activeClass );//class一旦削除
   const activeIndex = $(this).index(productImage); //インデックス取得
   $( '.js-image-zoom li' ).eq( activeIndex ).addClass( activeClass );//class付与
   //拡大用のタグを一度空にしてからく拡大するimgを追加
   $( '.js-image-zoom-active' ).html( '' ).append( $( this ).clone() );*/

   //現在地を記憶して、ページ上部に移動
   //scrollPosition = $(window).scrollTop();
   $( 'html, body' ).scrollTop( 0 );

   //拡大画像を表示
   $( '.js-image-zoom__container' ).addClass( 'is-open' );

 });

 //閉じるボタンをクリック時
 $( '.js-image-zoom__close' ).on( 'click', function(){
   //拡大画像を非表示
   $( '.js-image-zoom__container' ).removeClass( 'is-open' );
 });
};

/**
* トグル
*/
sanko.itemDetail.toggle = function(){
 // ボタンクリックで、同階層のコンテンツを開閉
 $('.js-toggle-button').on('click',function(){
   $(this).siblings('.js-toggle-content').slideToggle();
   $(this).toggleClass('is-active');
 });
};

/**
* バリエーションリストの展開制御
*/
sanko.itemDetail.openVariation = function(){
  // カラーが1色の場合は、最初から展開しておく
  if($('.js-variant-color').length === 1){
    const targetButton = '.js-variant-color .js-toggle-button';
    $(targetButton).siblings('.js-toggle-content').slideToggle();
    $(targetButton).toggleClass('is-active');
  }
}

/**
* カート一括投下
*/
sanko.itemDetail.addProductsToCart = function(){
  $(document).on('click', '.js-product-form__submit', function(){
    const productArrayCart = [];
    let propertiesArray = {};

    // 刺繍加工をつけられる商品の場合
    if($('input[name="刺繍加工"]').length > 0){
      /* アイテムプロパティを取得
      properties: {
      '刺繍加工': '左胸',
      '糸カラー': 'レッド',
      '書体': '筆記体',
      'テキスト': 'SAMPLE'
      }*/
      // 選択された「刺繍加工」の値をアイテムプロパティに格納
      propertiesArray['刺繍加工'] = $('input[name="刺繍加工"]:checked').val();
      
      // 刺繍加工（1か所）の1か所目 or 刺繍加工（2か所）を選択した場合
      if($('#emb-pos-1:checked').length || $('#emb-pos-3:checked').length){
        propertiesArray[$('#emb-color-1').attr('name')] = $('#emb-color-1').val();
        propertiesArray[$('#emb-type-1').attr('name')] = $('#emb-type-1').val();
        propertiesArray[$('#emb-text-1').attr('name')] = $('#emb-text-1').val();
      }
      
      // 刺繍加工（1か所）の2か所目 or 刺繍加工（2か所）を選択した場合
      if($('#emb-pos-2:checked').length || $('#emb-pos-3:checked').length){
        propertiesArray[$('#emb-color-2').attr('name')] = $('#emb-color-2').val();
        propertiesArray[$('#emb-type-2').attr('name')] = $('#emb-type-2').val();
        propertiesArray[$('#emb-text-2').attr('name')] = $('#emb-text-2').val();
      }
    }

    //バリエーションの数だけ処理
    $('input[data-cart-quantity]').each(function(){
      const item = {};
      // 数量が1以上ならバリアントIDと数量をポスト用の配列に格納
      const variantId = parseInt($(this).attr('data-quantity-variant-id'), 10);
      const quantity = parseInt($(this).val(), 10);
      if( quantity >= 1){
        item.quantity = quantity;
        item.id = variantId;
        item.properties = propertiesArray;
        productArrayCart.push(item);
      }
    });

    // 刺繡加工を希望する場合は、選択した数量分だけ刺繍加工費用を追加
    if($('#emb-pos-none:checked').length < 1 && $('input[name="刺繍加工"]').length > 0){
      productArrayCart.push(sanko.itemDetail.addEmbroideryCost());
    }
    
    // 数量が未選択であれば投下処理はしない
    if(productArrayCart.length < 1){
      return false;
    }

    // POST
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: productArrayCart })
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(errorText => {
          const status = response.status;
          const statusText = response.statusText || 'Unknown Error';
          // エラーオブジェクトをthrowし、catchブロックで捕捉します
          throw new Error(`HTTP error! Status: ${status} ${statusText}, Response: ${errorText}`);
        });
      }
      // 成功時はJSONとしてパースします
      return response.json();
    })
    .then(data => {
      // 成功したら、カートページへリダイレクト
      console.log('success');
      window.location.href = '/cart/';
    })
    .catch(error => {
      // エラー時
      console.error('fail', error); // $.ajaxのfailと同様にエラーオブジェクト全体をログに出力
      alert('購入可能な数量を超えています。');
    });
  });
};

/**
* 刺繍加工費用のitemObjectを生成
*/
sanko.itemDetail.addEmbroideryCost = function(){
  // 刺繍加工費用のバリアントID
  const variantId_1_Hidden = document.getElementById('embroidery-1-variant-id');
  let variantId_1, variantId_2;
  if (variantId_1_Hidden) {
    variantId_1 = variantId_1_Hidden.value; // 刺繍加工費用（1箇所）
    variantId_1 = Number(variantId_1_Hidden.value); // 刺繍加工費用（1箇所）
  }
  const variantId_2_Hidden = document.getElementById('embroidery-2-variant-id');
  if (variantId_2_Hidden) {
    variantId_2 = variantId_2_Hidden.value; // 刺繍加工費用（1箇所）
  }

  // カート追加用のオブジェクト
  const item = {};

 // 刺繍加工の選択状態に応じて刺繍費用を設定
 if($('#emb-pos-1:checked').length || $('#emb-pos-2:checked').length){
   // 1箇所の場合
   item.id = variantId_1;
 
 }else if($('#emb-pos-3:checked').length){
   // 2箇所の場合
   item.id = variantId_2;
 }

 // 商品のバリエーション合計数量を取得して、加工費用の数量に設定
 const total = sanko.itemDetail.getTotalInventory();
 item.quantity = parseInt(total, 10);

  // 刺繍加工費用のバリアントIDと数量を返す
  return item;
};

/**
* 刺繍加工のフォーム制御
*/
sanko.itemDetail.controlEmbroidery = function(){
 $('.js-toggle-radio').on('click', function(){
   // 刺繍加工の選択によるフォームの表示制御
   sanko.itemDetail.controlEmbroidery.toggleForm(this);
 });

 // 刺繍加工のテキスト欄の文字数制限
 sanko.itemDetail.controlEmbroidery.limitCharacters();
};

/**
* 刺繍加工の選択によるフォームの表示制御
*/
sanko.itemDetail.controlEmbroidery.toggleForm = function(target){
 // 加工位置2箇所が選択されたら、刺繍入力フォームを2つ表示
 if( $(target).attr('id').indexOf('3') !== -1 ){
   $(target).parents('.js-toggle-radio-group').find('.js-toggle-content').slideDown();
 // 加工位置が1か所目が選択されたら、入力フォームを1つ目表示
 }else if( $(target).attr('id').indexOf('1') !== -1 ){
   $(target).parents('.js-toggle-radio-group').find('.js-toggle-content[data-toggle-value="emb-pos-2"]').slideUp();
   $(target).parents('.js-toggle-radio-group').find('.js-toggle-content[data-toggle-value="emb-pos-1"]').slideDown();
 // 加工位置が2か所目が選択されたら、入力フォームを2つ目表示
 }else if( $(target).attr('id').indexOf('2') !== -1 ){
   $(target).parents('.js-toggle-radio-group').find('.js-toggle-content[data-toggle-value="emb-pos-1"]').slideUp();
   $(target).parents('.js-toggle-radio-group').find('.js-toggle-content[data-toggle-value="emb-pos-2"]').slideDown();
 // 刺繍加工しない場合は、入力フォームを非表示
 }else{
   $(target).parents('.js-toggle-radio-group').find('.js-toggle-content').slideUp();
 }
};


// 刺繍加工のテキスト欄の文字数制限
sanko.itemDetail.controlEmbroidery.limitCharacters = function(){
 $('.js-embroidery-text').on('input', function(){
   // 16バイトまでしか入力できないように制御
   illm.common.enforceByteLimit(this, 16);
 });
};

/**
* カートボタンの制御
*/
sanko.itemDetail.cartButton = function(){
 $('.js-embroidery-form input, .js-embroidery-form select, .quantity__input').on('change input', function(){
   sanko.itemDetail.cartButton.updateCartButtonState();
 });
};

/**
* カートボタンの制御（メイン）
*/
sanko.itemDetail.cartButton.updateCartButtonState = function(){
 const $button = $('.js-product-form__submit'); // カートボタンのセレクタ
 const selectedId = $('input[name="刺繍加工"]:checked').prop('id'); // ラジオ選択値取得
 const isQuantityValid = sanko.itemDetail.cartButton.validateQuantity();// 数量が1以上か
 let isFormValid = false;//刺繍加工の入力フォームが入力済かどうか（初期値：未入力）

 // 刺繍加工の選択肢がある場合
 if( $('.js-embroidery-form').length ){
   isFormValid = sanko.itemDetail.cartButton.validateEmbroideryForm(selectedId);
   
 // 刺繍加工の選択肢がなければ、数量チェックのみでOK
 }else{
   isFormValid = true;
 }

 // 数量ボックス、刺繍加工の入力フォームの両方の入力があればカート追加可能
 if(isQuantityValid && isFormValid){
   $button.prop('disabled', false);
 }else{
   $button.prop('disabled', true);
 }
};

/**
* 全SKUの数量が1以上入力されているかを判定
*/
sanko.itemDetail.cartButton.validateQuantity = function(){
 let isQuantityValid = false;//各SKUの数量が入力済みかどうか（初期値：未入力）

 // 各SKUの数量を合算した数を取得
 const total = sanko.itemDetail.getTotalInventory();

 // 数量が1つでも入力されていれば有効化
 if(total>=1){
   isQuantityValid = true;
 // 数量が入ってなければ無効化
 }else{
   isQuantityValid = false;
 }
  
 return isQuantityValid;
};

// 
/**
 * 各SKUの数量を合計を取得
 */
sanko.itemDetail.getTotalInventory = function(){
 let total = 0;// 合計数量を初期化
 // 全ての数量入力欄
 $('.quantity__input').each(function () {
   // 取得した値を数値に変換
   const val = parseInt($(this).val(), 10); 
   if (!isNaN(val)) {
     // 有効な数値であれば、合計に加算
     total += val;
   }
 });
  
 // 合計数量を返す
 return total;
};

/**
* 刺繍加工フォームの入力が有効かどうか判定
*/
sanko.itemDetail.cartButton.validateEmbroideryForm = function(selectedId){
 const cartButton = sanko.itemDetail.cartButton;
 
 // 「希望しない」なら即有効化
 if (selectedId.indexOf('none') != -1) {
   return true;
   
 // 1か所目
 } else if (selectedId.indexOf('1') != -1) {
   if (cartButton.isEmbroideryInputFilled(1)) {
     return true;
   }
   
 // 2か所目
 }else if(selectedId.indexOf('2') != -1){
   if (cartButton.isEmbroideryInputFilled(2)) {
     return true;
   }
   
 // 2か所
 }else if (selectedId.indexOf('3') != -1) {
   if (cartButton.isEmbroideryInputFilled(1) && cartButton.isEmbroideryInputFilled(2)) {
     return true;
   }
 }

 // 未入力なら無効化
 return false;
};

/**
 * 刺繍加工の入力フォームのチェック判定
 * @param {string|number} suffix - 刺繍加工箇所の識別子 (例: 1, 2)
 * @returns {boolean} 全ての項目が入力済みであれば true、そうでなければ false
 */
sanko.itemDetail.cartButton.isEmbroideryInputFilled = function(suffix){
  // 各刺繍加工入力フォーム要素を、suffix を使って動的に取得
  const textInput = $(`#emb-text-${suffix}`);   // テキスト入力欄の要素
  const colorSelect = $(`#emb-color-${suffix}`); // 糸カラー選択プルダウンの要素
  const typeSelect = $(`#emb-type-${suffix}`);   // 書体選択プルダウンの要素
 
  // 各フォーム要素から現在の値を取得
  const text = textInput.val();    // テキスト入力欄の値
  const color = colorSelect.val(); // 糸カラー選択の値
  const type = typeSelect.val();   // 書体選択の値
  
 let trimmedText = "";
 // テキスト値が存在する場合のみ、前後の空白を削除
 if (text !== null && text !== undefined) {
   trimmedText = text.trim();
 }
 
 // すべての値が存在しているかを個別にチェック
 const isTextValid = trimmedText.length > 0;
 const isColorValid = color !== undefined && color !== "";
 const isTypeValid = type !== undefined && type !== "";

// 全ての項目が有効であればtrueを返す
 if (isTextValid && isColorValid && isTypeValid) {
   return true;
 } else {
   // 一つでも未入力または無効な項目があればfalseを返す
   return false;
 }
};

/**
* 糸カラー見本・書体見本の制御
*/
sanko.itemDetail.controlEmbroiderySample = function(){
  const activeClass = 'is-active';//タブのアクティブclass
  const openClass = 'is-open';//ポップアップのアクティブclass

  let sampleCategory;
  let targetSelect;
  
  $('.js-panel-button[data-sample]').each(function(){
    // ポップアップを表示したら
    $(this).on('click', function(){
      targetSelect = $(this).parents('dl').find('select');
      sampleCategory = $(this).data('sample');
      // 一旦見本のタブ切り替えの表示をリセット
      $('.js-tab__button[data-sample], .js-tab__content[data-sample]').removeClass(activeClass);
      // クリックした見本を表示
      $(`.js-tab__button[data-sample="${sampleCategory}"], .js-tab__content[data-sample="${sampleCategory}"]`).addClass(activeClass);
    });
  });

  $('.js-sample-value').each(function(){
    // 見本を選択したら
    $(this).on('click', function(){
      const sampleValue = $(this).data('value');
      // プルダウンに選択した値をセット
      targetSelect.val(sampleValue).trigger('change');
      // カートボタンのチェック処理
      sanko.itemDetail.cartButton.updateCartButtonState();
      // ポップアップを閉じる
      $(this).parents('.js-panel-container').removeClass(openClass);
      $('body').removeClass( 'is-panel-open overflow-hidden-desktop');
    });
  });
};

/**
* サイズを商品情報内に出力する
*/
sanko.itemDetail.outputProductSizes = function(){
  // 該当商品の全サイズのinputタグを取得
  const sizesInput = document.getElementById("product-sizes");
  // 出力先を取得
  const sizeTarget = document.querySelector(".js-product-spec-size td");

  // なければ、商品情報の「サイズ」項目を非表示にして、処理終了
  if (!sizesInput){
    sizeTarget.parentElement.style.display = "none";
    return;
  }

  // 全サイズの値を取得して、空白を削除
  const sizes = sizesInput.value.trim();
  // 末尾カンマ削除 + 全カンマを "、" に置換して、サイズの値に出力
  sizeTarget.textContent = sizes.replace(/,+$/, "").replace(/,/g, "、");;

};

/**
* 配送希望日の制御
*/
sanko.cart.deliveryDate = function(){
  // 配送希望日時を無効にする場合（店舗受け取り、刺繍加工費用がカートに入っている場合）
  if($('.js-cart-attribute').hasClass('cart-attribute--disable')){
     // プルダウンの値を空に変更
     $('#deliveryDate, #deliveryTime').val('');
    
    // カート属性を更新するfetchリクエスト
    fetch('/cart/update.js', {
      method: 'POST', // HTTPメソッド
      headers: {
        'Content-Type': 'application/json' // 送信するデータの形式を指定
      },
      body: JSON.stringify({ // 送信するデータをJSON文字列に変換
        attributes: {
          '配送希望日': '',
          '配送時間帯': ''
        }
      })
    })
    .then(response => {
      // レスポンスがOK (HTTPステータスが200番台) でない場合、エラーとして扱う
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // 成功時はJSONとしてパース
      return response.json();
    })
    .catch(error => {
      // エラー時
      console.error('更新失敗:', error);
    });
  }
};

/**
* カートページの数量変更時の処理
* （数量変更、商品削除時にカートの内容を監視し、必要に応じて刺繍加工費用の数量を調整する）
*/
sanko.cart.changeQuantity = function(){
 let changedInput = null;
 let removedObj = {};
  
 // 数量を変更したら、どの入力欄が変更されたかを特定
 $(document).on('change', '.quantity__input', function (event) {
   changedInput = event.target;
    // 数量変更があった場合は、削除情報をリセット
    removedObj = null; 
 });
  
 // 削除したら
 $(document).on('click', 'cart-remove-button', function (event) {
   removedInput = event.target;
   // 削除される商品の刺繍箇所数（1箇所or2箇所）と数量を取得し、オブジェクトに格納
   const embPosiCount = parseInt($(removedInput).attr('data-embroidery-count'));// 刺繍箇所の数（1箇所なのか2箇所なのか）
   const quantity = parseInt($(removedInput).attr('data-quantity'));//数量
   removedObj = {
     embPosiCount: embPosiCount,
     quantity: quantity
   };
    // 削除があった場合は、数量変更情報をリセット
    changedInput = null;
    // 刺繍加工費用の数量変更が完了するまでは、一旦数量の変更・削除をできないように制限
    sanko.cart.disableAllQuantityControls();
 });

  // 監視対象
  const observerTarget = document.querySelector('.cart__contents');
  console.log(observerTarget);
  // 更新を検知する要素がなければ処理終了
  if (!observerTarget){
    return;
  }

  // カートコンテンツ内のDOMの変化を監視し、コールバック関数を実行
  const observer = new MutationObserver(function (mutationsList, observer) {
    console.log('更新された');
    // 削除処理の繁栄を待つため、少し遅らせて処理
    setTimeout(async () => {
      // 変更または削除があった場合のみ処理を実行
      if (changedInput || removedObj) {
        // 刺繍加工費用の数量変更が完了するまでは、一旦数量の変更・削除をできないように制限
        sanko.cart.disableAllQuantityControls();
        // 削除完了後に最新カートを取得
        const res = await fetch('/cart.js');
        const cart = await res.json();
        console.log(changedInput);
        console.log(removedObj);
        // 刺繍加工対象の商品の数量に応じて、刺繍加工費用アイテムの数量を同期
        sanko.cart.syncEmbroideryQuantity(changedInput,removedObj);
        // 処理完了後、次のイベントに備えて変更・削除情報をリセット
        changedInput = null;
        removedObj = null;
      }
    }, 1000);
  });

  // 監視を開始
  // observer.observe(document.body, { childList: true, subtree: true });
  observer.observe(observerTarget, {
    childList: true, // 直接の子要素の追加・削除を監視
    subtree: true // 子孫要素の変更も含めて監視
  });
};

/**
* 数量変更と削除を一時的に無効化
*/
sanko.cart.disableAllQuantityControls = function() {
  // body直下にオーバーレイを追加しておく
  const overlay = document.getElementById('cart-overlay');
  overlay.style.display = 'flex';


 /*
 // すべての数量入力欄を取得
 const quantityInputs = document.querySelectorAll('.quantity__input');
 const removeLinks = document.querySelectorAll('.js-remove-button');

  // 数量変更の欄
  quantityInputs.forEach(quantityInput => {
    // 入力欄を無効化し、ユーザーからの入力を受け付けなくする
    quantityInput.disabled = true;
    quantityInput.classList.add('is-disabled');

    // 増減ボタンの要素を取得し、なければ処理終了
    const wrapper = quantityInput.closest('quantity-input');
    if (!wrapper){
      return;
    }
    // 増減ボタンをすべて無効化
    const buttons = wrapper.querySelectorAll('button.quantity__button');
    // 取得した増減ボタンをすべて無効化し、クリック操作を不能にする
    buttons.forEach(button => {
      button.disabled = true;            // クリック不可
      button.classList.add('is-disabled'); // 見た目も無効化
    });
    console.log('数量変更は無効化中');
 });
 
  // 削除ボタン
  removeLinks.forEach(removeLink => {
    removeLink.classList.add('is-disabled');
    // クリックイベントを止める
    removeLink.addEventListener('click', function(e) {
      //e.preventDefault();
      //e.stopPropagation();
      console.log('削除ボタンは無効化中');
    });
 });*/


};

/**
* 刺繍加工対象の商品の数量に応じて、刺繍加工費用アイテムの数量を同期
* @param {HTMLElement|null} changedInput - 数量が変更された入力欄のDOM要素。削除の場合はnull。
* @param {Object|null} removedObj - 削除された商品の刺繍関連情報を含むオブジェクト。数量変更の場合はnull。
*/
sanko.cart.syncEmbroideryQuantity = function(changedInput,removedObj){
  // 刺繍加工費用のバリアントID
  const variantId_1_Hidden = document.getElementById('embroidery-1-variant-id');
  let variantId_1, variantId_2;
  if (variantId_1_Hidden) {
    variantId_1 = Number(variantId_1_Hidden.value); // 刺繍加工費用（1箇所）
  }
  const variantId_2_Hidden = document.getElementById('embroidery-2-variant-id');
  if (variantId_2_Hidden) {
    variantId_2 = Number(variantId_2_Hidden.value); // 刺繍加工費用（1箇所）
  }

  let embroideryVariantId = '';// 現在処理対象の刺繍加工費用のバリアントID
  let embPosiCount = '';// 処理対象商品の刺繍箇所数（1または2）
  let updateQuantity = 0;// 更新後の刺繍加工費用の合計数量

 // 刺繍箇所の数（1箇所なのか2箇所なのか）を取得
 if(changedInput && $(changedInput).attr('data-embroidery-count')){
   // 数量変更の場合、変更された入力欄のdata属性から刺繍箇所数を取得
   embPosiCount = parseInt($(changedInput).attr('data-embroidery-count'));
 }else if(removedObj){
   // 商品削除の場合、removedObjから刺繍箇所数を取得
   embPosiCount = removedObj.embPosiCount;
 }

 // カート内の全アイテム内から、同じ刺繍箇所数の商品の合計数量を計算
 $('.cart-item').each(function(){
   const $input = $(this).find('.quantity__input');
   const itemEmbPosCount = parseInt($input.attr('data-embroidery-count'));// 対象商品の刺繍箇所の数（1箇所なのか2箇所なのか）
   const quantity = parseInt($input.attr('value'));// 対象の商品の数量
   // 対象商品の刺繍箇所数が現在処理中の刺繍箇所数と一致する場合のみ加算
   if(itemEmbPosCount === embPosiCount){
    updateQuantity += quantity;
   }
 });
 
  // 計算された刺繍箇所数に基づいて、対応する刺繍加工費用バリアントIDを設定
  if(embPosiCount === 1){
    embroideryVariantId = variantId_1;
  }else if(embPosiCount === 2){
    embroideryVariantId = variantId_2;
  }
  // 刺繍加工を希望しない商品は、リロードして終了
  if(!embroideryVariantId){
    location.reload();
  }
 
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('現在のカート', cart.items);
      // 全アイテムの key と quantity を確認
      cart.items.forEach(item => {
        console.log(item.key, item.quantity, item.title);
      });

      // カート情報から、対応する刺繍加工費用アイテムを検索
      let embroideryFeeItem = null;
      for (let i = 0; i < cart.items.length; i++) {
        let item = cart.items[i];
        if (item.variant_id === embroideryVariantId) {
          embroideryFeeItem = item;
          break;
        }
      }
      // 刺繍加工費用アイテムがカート内に存在する場合、その数量を更新
      if (embroideryFeeItem) {
        console.log(`箇所：${embPosiCount}/ 数量：${updateQuantity}`);
        sanko.cart.updateItemQuantity(embroideryFeeItem.key, updateQuantity);
      }else{
        location.reload();
      }
  });
};

/**
 * カート内の指定されたアイテムの数量を更新
 * @param {string} lineItemKey - 更新対象のバリアントID
 * @param {number} updateQuantity - 更新対象の新しい数量
 */
sanko.cart.updateItemQuantity = function(lineItemKey, updateQuantity) {
  console.log(lineItemKey,updateQuantity);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: updateQuantity
    })
  })
 .then(res => res.json())
 .then(() => {
    // ✅ 更新直後にカート全体を再取得
    return fetch('/cart.js');
  })
 .then(res => res.json())
 .then(data => {
  console.log('刺繍加工費用を更新しました',data);
  location.reload();
  //setTimeout(() => location.reload(), 100);
 });
};

/**
* 店舗受け取りの有効/無効の制御
*/
sanko.cart.controlStorePickup = function(){
  // 店舗受け取りのチェックボックス
  const pickupWrapper = document.querySelector('.js-pickup-checkbox');
  const pickupInput = pickupWrapper?.querySelector('input[type="checkbox"]');

  // 刺繍加工費用がカートにないまたは店舗受け取りチェックボックスがなければ処理終了
  if($('.js-cart-item-embroidery').length === 0 || !pickupInput){
    return;
  }

  // 店舗受け取りがカートに入っている場合
  if($('.js-cart-item-pickup').length > 0){
    // 店舗受け取りのチェックを外す
    pickupInput.checked = false;
    // 手動でチェンジイベントを発火させ、店舗受け取り商品を削除
    const event = new Event('change', { bubbles: true });
    pickupInput.dispatchEvent(event);
  }

  // 店舗受け取りのチェックボックスを無効化
  pickupInput.disabled = true;
  // 親に状態クラスを付与
  pickupWrapper.classList.add('is-disabled');
}

/**
* 店舗ページのスライダー
*/
sanko.shop.slider = function(){
  const margin_sp = 8;// SPの左右のマージン
  const margin_pc = 24;// PCの左右のマージン
  const slideSpeed = 600;// スライド時のスピード
  const pcBreakpoint = illm.common.breakpoint.pc;//PCのブレークポイント

  const shopSwiper = new Swiper('.js-shop-slider', {
    centeredSlides: true,
    loop: true,
    spaceBetween: margin_sp,
    slidesPerView: 'auto',
    speed: slideSpeed,
    allowTouchMove: true,
    /*autoplay: {
      delay: 0,
    },*/
    breakpoints: { 
      [pcBreakpoint]: {
        spaceBetween: margin_pc,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    },
  });
};

/**
* MVVの円のアニメーション制御
*/
sanko.company.animationCircle = function() {
  // アニメーション対象の要素
  const circle = document.querySelector('.js-mvv-circle');
  let circleInitialCenterY = 0;

  // 円の初期の中心位置を保存
  const circleRect = circle.getBoundingClientRect();
  circleInitialCenterY = window.scrollY + circleRect.top + circleRect.height / 2;

  // Intersection Observer の設定オプション
  const observerOptions = {
    root: null,
    rootMargin: '-40% 0px -40% 0px', // 画面中央付近20%の範囲を監視
    threshold: 0
  };

  // ある要素が画面に入ったかを監視
  const observer = new IntersectionObserver((entries, observer) => {
    // 対象要素を
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const targetRect = entry.target.getBoundingClientRect();
        const targetCenterY = window.scrollY + targetRect.top + targetRect.height / 2;// 要素の中心の絶対座標（ページ全体基準）
        const moveY = Math.round(targetCenterY - circleInitialCenterY);// 円の初期位置と要素の中心との差

        if (!circle.classList.contains('is-animating')) {
          circle.classList.add('is-animating');// アニメーション用のclassを付与
        }
         circle.style.transform = `translateY(${moveY}px)`;// 次の要素まで移動

        // アニメーション終了後にクラス削除（次回のため）
        circle.addEventListener('animationend', () => {
          circle.classList.remove('is-animating');
        }, { once: true });
      }
    });
  }, observerOptions);

  // 監視対象の要素
  const mvvHeads = document.querySelectorAll('.js-mvv-head');
  mvvHeads.forEach(head => {
    observer.observe(head);
  });
}

/**
* MVVの文字色制御
*/
sanko.company.controlTextColor = function() {
  // Intersection Observer の設定オプション
  const observerOptions = {
    root: null,// ビューポートを基準に監視
    rootMargin: '-40% 0px -40% 0px', // 画面中央付近20%の範囲を監視
    threshold: 0 // 1pxでも交差すれば「交差している」とみなす
  };

  // Intersection Observer のインスタンスを作成
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 画面中央付近に入ったとき、activeクラスを付与
        entry.target.classList.add('is-active');
      }
    });
  },observerOptions);

  // 監視対象の要素
  const mvvHeads = document.querySelectorAll('.js-text-color');
  // 各要素に対して監視を開始
  mvvHeads.forEach(head => {
    observer.observe(head);
  });
}

/**
* 固定メニューの表示・非表示の制御
*/
sanko.uniform.handleFixedMenu = function() {
  const $fixedMenu = $('.order__fixedmenu'); // 固定メニュー要素
  const $trigger = $('.order__contents-recommend-title'); // トリガー要素（この位置を超えたら表示）
  const $footer = $('.footer-banner'); // フッター要素（近づいたら非表示）

  // スクロール時の処理
  $(window).on('scroll', function() {
    const scrollTop = $(this).scrollTop(); // 現在のスクロール位置
    const triggerOffset = $trigger.offset().top; // トリガー位置
    const footerOffset = $footer.offset().top; // フッター位置
    const windowHeight = $(window).height(); // ウィンドウ高さ

    // トリガーより下、かつフッターに重ならない場合のみ表示
    if (scrollTop >= triggerOffset && (scrollTop + windowHeight) < footerOffset) {
      $fixedMenu.fadeIn();
    } else {
      $fixedMenu.fadeOut();
    }
  });
}

/**
* 納入実績のスライダー
*/
sanko.uniform.slider = function() {
  // カタログスライダーの初期化関数
  function initCatalogSliders() {
    document.querySelectorAll('.order-swiper').forEach((swiperEl, index) => {
      const wrapper = swiperEl.querySelector('.order-swiper-wrapper');
      const slides = swiperEl.querySelectorAll('.order-swiper-slide');
      const slideSpeed = 600;// スライド時のスピード

      // スライダー識別用のユニークなクラス名を追加
      const uniqueClass = `order-swiper-${index}`;
      swiperEl.classList.add(uniqueClass);

      // 画面幅が750px以上のときにSwiperを初期化
      if (window.innerWidth >= 750) {
        // Swiperが未初期化である場合のみ
        if (!swiperEl.swiper) {
          wrapper.classList.add('swiper-wrapper');

          new Swiper(`.${uniqueClass}`, {
            autoHeight: true, // 自動高さ調整
            //loop: true, // ループモード
            slidesPerView: 2.8, // 表示スライド数
            slidesPerGroup: 1, // スライド切り替え単位
            spaceBetween: 25, // スライド間のスペース
            speed: slideSpeed, // スライド速度（ミリ秒）
            navigation: {
              nextEl: `.${uniqueClass} .swiper-button-next`,
              prevEl: `.${uniqueClass} .swiper-button-prev`
            }
          });
        }
      } else {
        // モバイル表示時：Swiperを破棄し、縦並びレイアウトに戻す
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }

        slides.forEach((slide) => {
          slide.style.display = ''; // 初期状態に戻す
          slide.style.width = '100%';
          /*slide.style.marginBottom = '6.4rem';*/
        });

        wrapper.classList.remove('swiper-wrapper');
      }
    });
  }

  // ページ読み込み時とリサイズ時にスライダーを初期化
  window.addEventListener('load', initCatalogSliders);
  window.addEventListener('resize', () => {
    setTimeout(initCatalogSliders, 100); // リサイズ後に少し待ってから実行
  });
}

/**
* 「納品までの流れ」のステップ切り替え
*/
sanko.uniform.handleStepChange = function() {
  //「STEP2→」等の次のタブ切り替えのボタンをクリックしたら、
  $( '.js-step-link' ).on( 'click', function(){
    const $container = $(this).closest('.js-tab__container'); // 親を取得
    const activeIndex =  $container.find( '.js-step-link' ).index( this );//今のタブが何番目か取得
    const nextIndex = activeIndex + 1; //次のタブのインデックス
    //タブ切り替えの処理
    const targetTab = $( this ).parents( '.js-tab__container' ).find( '.js-tab__button ' ).eq( nextIndex );
    sanko.common.tabswitch(targetTab);
  });
}

/**
* 注文履歴ページ住所の整形（「日本」削除、郵便番号マーク追加）
*/
sanko.order.addressAdjust = function() {
 // .order-content-address クラス内の p 要素を対象とする
 $(".order-content-address p").each(function() {
   let $this = $(this);
   let html = $this.html();

   // 1. 「<br>日本」を削除する処理
   // 正規表現で、行末の <br>日本 または <br>日本<br> のパターンを削除します。
   let newHtml = html.replace(/<br>\s*日本\s*$/, ''); // 行末の「<br>日本」を削除
   newHtml = newHtml.replace(/<br>\s*日本(?=\s*<br>)/, ''); // <br>の間に挟まれた「日本」を削除

   // 2. 郵便番号の前に「〒」を挿入する処理
   // 「XXX-XXXX」形式の数字の前に「〒」を挿入します。
   newHtml = newHtml.replace(/(\b\d{3}-\d{4}\b)/g, '〒$1');

   // 更新されたHTMLを要素に設定する
   $this.html(newHtml);
 });
};





/*
 * ========================================
 * 初期処理
 * ========================================
 */
$(function() {
 
  // ----------------------------------------
  // Common
  // ----------------------------------------    
  if (!$('.page-login').length) {
    // スムーススクロール
    illm.common.smoothScroll();
  }

  // ページ上部のトピックスの表示制御
  if($('.js-header-topics-container').length){
   sanko.common.information();
  }

  // ヘッダーメニューの表示制御
  if($('.js-header-panel').length){
   sanko.common.setupHeaderMenuToggle();
  }
  
  // ヘッダーの候補ワードの検索処理
  if($('.js-search-word').length){
   sanko.common.search();
  }
  
  // ヘッダーのおすすめアイテムのスライダー
  if($('.js-header-recommend').length){
   sanko.common.recommendSlider();
  }
  
  // アコーディオンメニュー
  if($('.js-accordion-button').length){
   sanko.common.accordion();
  }
  
  // タブ切り替え
  if($('.js-tab__container').length){
    $( '.js-tab__button' ).on( 'click', function() {
      sanko.common.tabswitch($(this));
    });
  }
  
  //「新作」アイコンの表示制御
  if($( '.js-new-icon' ).length){
   // 現在時刻をサーバーから取得
   illm.common.getServerDate().then( date => {
     sanko.common.newicon(date);
   });
  }
 
  // 商品カードの画像のカルーセル
  if($('.js-item-carousel').length){
    sanko.common.itemCarousel();
  }

  // トグルのパネル表示
  if($('.js-panel-button').length){
    sanko.common.setupTogglePanel();
  }

  // ヘッダーの色の制御
  if($( '.js-light-header-section' ).length){
    sanko.common.controlHeaderColor();
  }

  // メインコンテンツの位置を画面上部に詰める処理
  if($('.js-align-top').length){    
    // ページ読込・リサイズ時に処理を呼び出す
    window.addEventListener('load', sanko.common.updateMainContentPosition);
    window.addEventListener('resize', sanko.common.updateMainContentPosition);
  }

  // ----------------------------------------
  // Top
  // ----------------------------------------
  if(illm.common.isPageTop()){

    if($('.js-home-visual').length){
      // 2カラムのMVを１カラムに置き換え
      sanko.top.adjustForMobileMainvisual();
      // キャプションの位置を制御
      sanko.top.moveMainVisualCaption();
    }
    
    // スクロールで画像をパララックス（明るさ調整）
    if($('.parallax-image').length){
      sanko.top.parallaxImageEffect();
    }

    // 「私たちのモノづくり」のスライダー
    if($('.js-home-blog-slider').length){
      sanko.top.featureSlider();
    }
  
  // ----------------------------------------
  // Itemlist
  // ----------------------------------------    
  } else if ($('.page-collection').length || illm.common.getCurrentUrl().match(/\/search$/)) {   
    // 絞り込みメニューをスクロールアップで表示
    if($('.js-filter-sticky').length){
      sanko.itemList.scrollUpRevealFilter();
    }

    // 絞り込みメニューを非表示制御（スマホ）
    if('.mobile-facets__open-wrapper'){
      sanko.itemList.controlDisplayFilter();
    }
  
    // 絞り込みメニューを閉じる処理
    /*if($('#FacetFiltersForm').length){
      sanko.itemList.CloseFilterMenu();
    }*/

  // ----------------------------------------
  // ItemDetail
  // ----------------------------------------
  } else if ($('.page-product').length) {
    // 商品画像のスライダー
    if($('.js-product-slider').length){
      sanko.itemDetail.productSlider();
    }

    // 商品画像の拡大処理
    if($('.js-product-slider').length){
      sanko.itemDetail.zoomProductImages();
    }
    
    // トグル
    if($('.js-toggle-button').length){
      sanko.itemDetail.toggle();
    }
    
    // バリエーションリストの展開制御
    if($('.js-variant-color').length){
      sanko.itemDetail.openVariation();
    }
    
    // カート一括投下
    if($('.js-product-slider').length){
      sanko.itemDetail.addProductsToCart();
    }
    
    // 刺繍加工のフォーム制御
    if($('.js-toggle-radio-group').length){
      sanko.itemDetail.controlEmbroidery();
    }
    
    // カートボタンの制御
    if($('.js-product-form__submit').length){
      sanko.itemDetail.cartButton();
    }
    
    // 糸カラー見本・書体見本の制御
    if($('.js-panel-button[data-sample]').length){
      sanko.itemDetail.controlEmbroiderySample();
    }

    // サイズを商品情報内に出力する
    if($('.js-product-spec-size').length){
      sanko.itemDetail.outputProductSizes();
    }


  // ----------------------------------------
  // Cart
  // ----------------------------------------
  } else if ($('.page-cart').length) {
    // 配送希望日の制御
    if($('.js-cart-attribute').length){
      sanko.cart.deliveryDate();
    }
    
    // カートページの数量変更時の処理
    if($('.js-cart-item-embroidery').length){
      sanko.cart.changeQuantity();
    }
  
    // 店舗受け取りの有効/無効の制御
    if($('.js-pickup-checkbox').length){
      sanko.cart.controlStorePickup();
    }

  // ----------------------------------------
  // Shop
  // ----------------------------------------    
  } else if ($('.page-shop').length) {
    // 店舗ページのスライダー
    if($('.js-shop-slider').length){
      sanko.shop.slider();
    }
  
  // ----------------------------------------
  // Company
  // ----------------------------------------    
  } else if ($('.page-company').length) {
    // MVVの円のアニメーション制御
    if($('.js-mvv-circle').length){
      sanko.company.animationCircle();
    }

    // MVVの文字色制御
    if($('.js-text-color').length){
      sanko.company.controlTextColor();
    }

  // ----------------------------------------
  // Company
  // ----------------------------------------    
  } else if ($('.page-uniform').length) {
    // 固定メニューの表示・非表示の制御
    sanko.uniform.handleFixedMenu();

    // 納入実績のスライダー
    sanko.uniform.slider();

    // 「納品までの流れ」のステップ切り替え
    sanko.uniform.handleStepChange();

  // ----------------------------------------
  // Cotact
  // ----------------------------------------    
  } else if ($('.page-contact').length) {
/*
    const intervalId = setInterval(() => {
      const iframe = document.querySelector('#MainContent iframe');
      console.log(iframe);
      if (iframe) {
        console.log('OK');
        clearInterval(intervalId); // 見つかったら監視終了
        clearTimeout(timeoutId);

        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            console.log("iframeの高さが変わった:", entry.contentRect.height);
          }
        });

        resizeObserver.observe(iframe);
      }
    }, 500); // 0.5秒ごとにチェック

    // 5秒経ったら監視終了
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      console.log("submitButton が見つからなかったので監視終了");
    }, 5000);*/

  }

});

/*
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  // HTML全体を監視
  const target = document.documentElement;

  const observer = new MutationObserver((mutationsList) => {
    console.log('MutationObserver 発火！', mutationsList);
  });

  observer.observe(target, {
    childList: true,   // 子ノードの追加・削除を監視
    subtree: true,     // 子孫ノードも監視
    attributes: true,  // 属性変更も監視
    characterData: true // テキスト変更も監視
  });

  console.log('MutationObserver が起動しました');

  // 2秒後にテスト用の要素を追加
  setTimeout(() => {
    const div = document.createElement('div');
    div.textContent = 'テスト要素';
    document.body.appendChild(div); // この瞬間に必ず MutationObserver が発火
  }, 2000);
}*/